import React, { useRef } from 'react';

import './Message.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import ComponentDropArea, { renderComponentDropArea, RenderComponentDropArea } from '../ComponentDropArea';
import DnDOverContent from '../common/DnDOverContent'
import { allowed_types_component_menu, allowed_types_component } from './DropContext';
import RowContainer from './RowContainer';
import { getAllTypes_component, DnD_element_type_category } from '../common/ConstantValues';
import { DragHandle_BotProfile } from '../common/Common_styles';
import DnDContext from '../DnDContext';
import DraggableComponent from './DraggableComponent';
import classnames from 'classnames'

const Message = (props) => {
  const { 
    rows, 
    index, 
    isDragging, 
    disable, 
    editing, 
    currentEditMessage, 
    editingIndexes,
    currentEditSlidePage,
  } = props
  // const {
  //   editing_message_index,
  //   editing_row_index,
  //   editing_slide_page_index,
  // } = editingIndexes
  const { onDropMenuComponent, onDropComponent, messageActions } = props
  const {
    deleteMessage,
  } = messageActions

  const messageRef = useRef()

  // 0번째 고정된 위치에 메뉴 컴포넌트 onDrop
  const _onDropMenuComponent = (e) => {
    e = {
      ...e,
      message_index: index,
      row_index: 0
    }
    onDropMenuComponent(e)
  }

  /**
   * 0번째 고정된 위치에 컴포넌트 onDrop
   * @param {Object} e 
   */
  const _onDropComponent = (e) => {
    e = {
      ...e,
      message_index: index,
      row_index: 0,
    }
    onDropComponent(e) // 구조상 -1사용 시 0으로(사용자 입장) 값 설정
  }

  const deleteThisMessage = (e) => {
    if (window.confirm("삭제한 후 되돌릴 수 없습니다. 삭제하시겠습니까?")) {
      deleteMessage(index)
    }
  }

  let overContentArg = {
    minHeight: 100,
    opacity: 0.8,
  }

  // Row Rendering
  const renderRows = (rows, isDragging) => {
    if (rows) {
      if (rows.length > 0) {
        overContentArg = {
          ...overContentArg,
          minHeight: 15
        }
        // Add index 0 drop area
        let render_result = [isDragging ? ( // Rendered component
          <RenderComponentDropArea
            key={'rendered_component_drop_first'}
            onDrop={_onDropComponent}
            DnDOverContent={DnDOverContent}
            overContentArg={overContentArg}
            customStyle={{width: "calc(100% - 10px)", minHeight: 15,}}
            allowed_types={allowed_types_component}
          />
        ) : ( // Menu component
          <RenderComponentDropArea
            key={'menu_component_drop_first'}
            onDrop={_onDropMenuComponent}
            DnDOverContent={DnDOverContent}
            overContentArg={overContentArg}
            customStyle={{width: 'calc(100% - 10px)', minHeight: 15,}}
            allowed_types={allowed_types_component_menu}
          />
        )]
        overContentArg = {
          ...overContentArg,
          minHeight: 30
        }
        render_result = render_result.concat(rows.map((row, i) => (
          <RowContainer
            key={i}
            message_index={index}
            row_index={i+1}
            row={row}
            isDragging= {isDragging}
            currentEditMessage= {currentEditMessage}
            // editingIndexes={editingIndexes}
            editing_message_index= {props.editing_message_index}
            editing_row_index= {props.editing_row_index}
            editing_slide_page_index= {props.editing_slide_page_index}
            messageActions={messageActions}
            currentEditSlidePage={currentEditSlidePage}
          />
        )))
        return render_result
      }
    }

    /**
     * Rendering init drop area
     */
    return isDragging ? ( // Component drop rendering
      <RenderComponentDropArea
        key={0}
        onDrop={_onDropComponent}
        DnDOverContent={DnDOverContent}
        overContentArg={overContentArg}
        allowed_types={allowed_types_component}
      />
    ) : ( // Component menu drop rendering
      <RenderComponentDropArea
        key={1}
        onDrop={_onDropMenuComponent}
        DnDOverContent={DnDOverContent}
        overContentArg={overContentArg}
        allowed_types={allowed_types_component_menu}
      />
    )
  }

  const msgLayoutClassname = classnames('message-layout', {
    'disable': disable,
  })

  return (
    <div className={msgLayoutClassname}>
      <DraggableComponentWrap
        messageIndex={index}
        // rowIndex={}
        // rowIndexDetail={}
        // componentIndex={}
        handleWrapCSS={handleWrapCSS}
        verticalLeftAreaCSS={verticalLeftAreaCSS}
        onDragStart={(e) => {console.log('e :', e);}} 
        onDragEnd={(e) => {console.log('e :', e);}}
        renderedHeight={messageRef ? messageRef.current ? messageRef.current.offsetHeight : null : null}
        // renderedHeight={(() => {
        //   if (messageRef) {
        //     if (messageRef.current) {
        //       console.log('messageRef.current.offsetHeight :', messageRef.current.offsetHeight);
        //       return messageRef.current.offsetHeight
        //     }
        //   }
        // })()}
        cat_type={DnD_element_type_category.REN_ELEM} 
        type={'MESSAGE'} prefix_type={null}
        disable={editing} // Apply disable effect to bot profile image
      >
        <div ref={messageRef} className="chat-message">
          <button className="delete-btn" onClick={deleteThisMessage}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
          {renderRows(rows, isDragging)}
        </div>
      </DraggableComponentWrap>

      {/* <div> */}
        {/* <div className="chat-profile"> */}
          {/* Chatbot profile image */}
        {/* </div> */}
      {/* </div> */}
      {/* <div className="chat-message"> */}
        {/* <button className="delete-btn" onClick={deleteThisMessage}>
          <FontAwesomeIcon icon={faTimes} />
        </button> */}
        {/* {renderRows(rows, isDragging)} */}
      {/* </div> */}
    </div>
  )
}
const handleWrapCSS = {
  paddingLeft: 0,
  paddingRight: 0,
}

const verticalLeftAreaCSS = {
  display: 'grid',
  gridTemplateColumns: '60px calc(100% - 60px)',
}
const DraggableComponentWrap = (props) => {
  const { disable } = props
  return (
    <DnDContext>
      <DraggableComponent dragHandle={DragHandle_BotProfile(disable)} disableDrag={disable} {...props}>
        {props.children}
      </DraggableComponent>
    </DnDContext>
  )
}



export default Message